module.exports = __webpack_public_path__ + "static/media/list-alt.5305e604.svg";